<input type="text"
       class="c-form-control"
       [value]="searchTerm"
       (keydown.tab)="inputBlur($event)"
       placeholder="{{placeholder | translate}}"
       tabindex="{{tabindex}}" autocomplete="false" #searchInput/>

<ihd-pop [(show)]="isShowingSearch" class="ihd-popover c-google-autocomplete-popover"
             [class.has-results]="hasGoogleSuggestions" [autoWidth]="true"
             (onBackdropClick)="inputBlur($event)"
             [modal]="true" direction="bottom" [autoHide]="false">

    <ng-template>
        <div class="c-scroller h-100">
            <div class="c-list c-list--sm">
                <div class="c-list__item c-list__item--no-divider px-2 is-clickable" (click)="selectMatch($event, defaultMatch)"
                     *ngIf="!selectedMatches.length && allowCustom">
                    {{ defaultMatch.label }}
                </div>
    
                <div class="c-list__item c-list__item--no-divider px-2 is-clickable" (click)="selectMatch($event, match)"
                     *ngFor="let match of selectedMatches; trackBy: trackIdFn;">
                    {{ match.label }}
                </div>
            </div>
        </div>
    </ng-template>
</ihd-pop>
